import { useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from '../../../../App';
import TransactionDetails from '../TransactionDetails';
import SIBTransactionCard from './TransactionCard';
import styles from './index.module.css';

type Props = {
  transaction: any;
  showDateOfTransaction?: boolean;
  isPendingRec?: boolean;
  isCompletedRec?: boolean;
  className?: string;
  transactionImageBGProp?: string;
  iconSize?: string;
  showTransactionDetails?: boolean;
};

const SIBTransaction: React.FC<Props> = ({
  transaction,
  showDateOfTransaction,
  isPendingRec,
  isCompletedRec,
  className,
  transactionImageBGProp,
  iconSize,
  showTransactionDetails = false,
}) => {
  const { backButtonHandler, setBackButtonHandler }: any =
    useContext(AppContext);
  const [isDetailSheetOpen, setIsDetailSheetOpen] = useState(false);
  // The back handler that was active before this sheet opened, so back returns
  // to the screen behind the sheet instead of falling through to the parent
  // handler (which navigates to the dashboard).
  const previousBackHandler = useRef<any>(null);

  const closeSheet = () => {
    setIsDetailSheetOpen(false);
    const prev = previousBackHandler.current;
    previousBackHandler.current = null;
    setBackButtonHandler(() => prev ?? (() => {}));
  };

  const openSheet = () => {
    previousBackHandler.current = backButtonHandler;
    setBackButtonHandler(() => closeSheet);
    setIsDetailSheetOpen(true);
  };

  // If we unmount while the sheet is still open, restore the previous handler
  // so we don't leave the back button pointing at this closed sheet.
  useEffect(() => {
    return () => {
      if (previousBackHandler.current) {
        const prev = previousBackHandler.current;
        setBackButtonHandler(() => prev);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isDetailSheetOpen && (
        <TransactionDetails closeSheet={closeSheet} transaction={transaction} />
      )}
      <div
        className={`${styles.transactionCard} ${className ?? ''}`}
        id={transaction.id ? transaction.id : transaction.category}
        onClick={() => showTransactionDetails && openSheet()}
      >
        <SIBTransactionCard
          transaction={transaction}
          iconSize={iconSize}
          transactionImageBGProp={transactionImageBGProp}
          isCompletedRec={isCompletedRec}
          isPendingRec={isPendingRec}
          showDateOfTransaction={showDateOfTransaction}
        />
      </div>
    </>
  );
};

export default SIBTransaction;
